package it.maicol07.gamerlogue.ui.navigation.rootTree

import androidx.navigation3.runtime.EntryProviderScope
import androidx.navigation3.runtime.NavKey
import io.github.fopwoc.nav3ksp.NavTreeBuilder
import it.maicol07.gamerlogue.ui.navigation.DetailPaneMetadata as DetailPaneMetadata
import it.maicol07.gamerlogue.ui.navigation.DiscoverPaneMetadata as DiscoverPaneMetadata
import it.maicol07.gamerlogue.ui.navigation.ListPaneMetadata as ListPaneMetadata
import it.maicol07.gamerlogue.ui.views.auth.Login as Login
import it.maicol07.gamerlogue.ui.views.calendar.Calendar as Calendar
import it.maicol07.gamerlogue.ui.views.comments.ReviewDetailView as ReviewDetailView
import it.maicol07.gamerlogue.ui.views.discover.DiscoverView as DiscoverView
import it.maicol07.gamerlogue.ui.views.events.EventListView as EventListView
import it.maicol07.gamerlogue.ui.views.game.GameDetailView as GameDetailView
import it.maicol07.gamerlogue.ui.views.game.GameReviewsView as GameReviewsView
import it.maicol07.gamerlogue.ui.views.library.Library as Library
import it.maicol07.gamerlogue.ui.views.library.ReviewEditorView as ReviewEditorView
import it.maicol07.gamerlogue.ui.views.list.GameListView as GameListView
import it.maicol07.gamerlogue.ui.views.profile.ProfileView as ProfileView
import it.maicol07.gamerlogue.ui.views.profile.UserProfileView as UserProfileView
import it.maicol07.gamerlogue.ui.views.settings.SettingsView as SettingsView
import it.maicol07.gamerlogue.ui.views.settings.categories.AppearanceView as AppearanceView
import it.maicol07.gamerlogue.ui.views.settings.categories.LibraryImportPreviewView as LibraryImportPreviewView
import it.maicol07.gamerlogue.ui.views.settings.categories.LinkedServicesView as LinkedServicesView
import it.maicol07.gamerlogue.ui.views.settings.categories.ServerSettingsView as ServerSettingsView
import it.maicol07.gamerlogue.ui.views.settings.categories.ServiceSyncView as ServiceSyncView
import it.maicol07.gamerlogue.ui.views.social.ActivityFeedView as ActivityFeedView
import it.maicol07.gamerlogue.ui.views.social.BlockedUsersView as BlockedUsersView
import it.maicol07.gamerlogue.ui.views.social.NotificationsView as NotificationsView
import it.maicol07.gamerlogue.ui.views.social.UserConnectionsView as UserConnectionsView
import it.maicol07.gamerlogue.ui.views.userlist.UserListDetailView as UserListDetailView

public object RootNavTreeBuilder : NavTreeBuilder() {
  override fun EntryProviderScope<NavKey>.branchesEntry() {
    entry<RootNavTree.UserListDetail>(metadata = DetailPaneMetadata.metadata()) {
      UserListDetailView(listId = it.listId)
    }
    entry<RootNavTree.UserConnections>(metadata = ListPaneMetadata.metadata()) {
      UserConnectionsView(userId = it.userId, kind = it.kind)
    }
    entry<RootNavTree.BlockedUsers>(metadata = ListPaneMetadata.metadata()) {
      BlockedUsersView()
    }
    entry<RootNavTree.Notifications>(metadata = ListPaneMetadata.metadata()) {
      NotificationsView()
    }
    entry<RootNavTree.ActivityFeed>(metadata = ListPaneMetadata.metadata()) {
      ActivityFeedView()
    }
    entry<RootNavTree.EventList>(metadata = ListPaneMetadata.metadata()) {
      EventListView()
    }
    entry<RootNavTree.Calendar>(metadata = ListPaneMetadata.metadata()) {
      Calendar()
    }
    entry<RootNavTree.ServiceSync>(metadata = DetailPaneMetadata.metadata()) {
      ServiceSyncView(service = it.service, action = it.action)
    }
    entry<RootNavTree.ServerSettings>(metadata = DetailPaneMetadata.metadata()) {
      ServerSettingsView()
    }
    entry<RootNavTree.LinkedServices>(metadata = DetailPaneMetadata.metadata()) {
      LinkedServicesView()
    }
    entry<RootNavTree.LibraryImportPreview>(metadata = DetailPaneMetadata.metadata()) {
      LibraryImportPreviewView(service = it.service, mode = it.mode)
    }
    entry<RootNavTree.Appearance>(metadata = DetailPaneMetadata.metadata()) {
      AppearanceView()
    }
    entry<RootNavTree.Settings>(metadata = DetailPaneMetadata.metadata()) {
      SettingsView()
    }
    entry<RootNavTree.Profile>(metadata = DetailPaneMetadata.metadata()) {
      ProfileView()
    }
    entry<RootNavTree.UserProfile>(metadata = DetailPaneMetadata.metadata()) {
      UserProfileView(userId = it.userId)
    }
    entry<RootNavTree.Login>(metadata = DetailPaneMetadata.metadata()) {
      Login()
    }
    entry<RootNavTree.ReviewDetail>(metadata = DetailPaneMetadata.metadata()) {
      ReviewDetailView(entryId = it.entryId, userId = it.userId)
    }
    entry<RootNavTree.ReviewEditor>(metadata = DetailPaneMetadata.metadata()) {
      ReviewEditorView(entryId = it.entryId)
    }
    entry<RootNavTree.Library>(metadata = ListPaneMetadata.metadata()) {
      Library()
    }
    entry<RootNavTree.GameList>(metadata = ListPaneMetadata.metadata()) {
      GameListView(section = it.section, eventId = it.eventId, eventName = it.eventName, preset = it.preset, libraryStatus = it.libraryStatus, libraryUserId = it.libraryUserId, pick = it.pick)
    }
    entry<RootNavTree.Discover>(metadata = DiscoverPaneMetadata.metadata()) {
      DiscoverView()
    }
    entry<RootNavTree.GameDetail>(metadata = DetailPaneMetadata.metadata()) {
      GameDetailView(gameId = it.gameId, coverImageId = it.coverImageId, gameName = it.gameName)
    }
    entry<RootNavTree.GameReviews>(metadata = DetailPaneMetadata.metadata()) {
      GameReviewsView(gameId = it.gameId)
    }
  }
}
